import React, { useState } from 'react';
import { Section } from './Section';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Qué pasa si dejo de pagar?',
  a: 'Tenemos periodos de gracia y opciones de valores garantizados.'
}, {
  q: '¿Es deducible de impuestos?',
  a: 'Sí, bajo los artículos 151 o 185 de la LISR según tu perfil.'
}, {
  q: '¿Por qué Seguros Monterrey?',
  a: 'Por sus más de 110 años de solidez financiera en México.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section bg="navy" data-id="element-56">
      <div className="max-w-3xl mx-auto" data-id="element-57">
        <div className="text-center mb-12" data-id="element-58">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-59">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto" data-id="element-60"></div>
        </div>

        <div className="space-y-4" data-id="element-61">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-gold/50 bg-navy-light' : 'border-white/10 bg-navy'}`} data-id="element-62">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-63">
                  <span className="text-lg font-medium text-white pr-8" data-id="element-64">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-gold transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-65" />
                </button>

                <AnimatePresence data-id="element-66">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-67">
                      <div className="px-6 pb-5 text-gray-light" data-id="element-68">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </Section>;
}